import React, { Component } from "react";
import { Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import config from 'react-global-configuration';
import moment from 'moment'
import flat from 'flat'
import flatten from "flat";



class Users extends Component {
  constructor(props) {
    super(props);
    
    let authUser = JSON.parse(sessionStorage.getItem('authUser'));
    this.state = {
        users: [],
        authUser: authUser
    };

    this.getUsers()
  }

 

  handleRowClick = (id) => {
      console.log(id)
      this.props.history.push("/user/"+id)
  }

  getUsers = () => {
      console.log(this.state.user)
    fetch(config.get('apiUrl')+'admin/users',{
        headers: {
            Authorization: 'Bearer '+ this.state.authUser.token
        }
    })
    .then(res=>res.json())
    .then((data)=> {
        console.log(data)
        data.map(user => {
            user.clickEvent = e => this.handleRowClick(user.uuid)
            user.isAdmin = user.isAdmin === true ? "Admin" : "Regular"
        })
        Object.keys(data).forEach(function(key) {
            data[key] = flatten(data[key])
        });
        this.setState({
            users: data
        })
        
    })
}

  render() {
    const data = {
      columns: [
        {
          label: "First name",
          field: "firstName",
          sort: "asc",
          width: 150
        },
        {
          label: "Surname",
          field: "surname",
          sort: "asc",
          width: 270
        },
        {
          label: "Type",
          field: "isAdmin",
          sort: "asc",
          width: 200
        }
      ],
      rows: this.state.users
      
    };

    return (
      <React.Fragment>
        <div className="container-fluid">
          <Row className="align-items-center">
            <Col sm={6}>
              <div className="page-title-box">
                <h4 className="font-size-18">Users</h4>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/#">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Users</li>
                </ol>
              </div>
            </Col>

          </Row>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                <Link to="/newuser" className="waves-effect">
                <Button color="primary" className="mr-1">
                               Add user
                            </Button>
                </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">

                  <MDBDataTable 
                    responsive 
                    bordered 
                    className="rows-clickable"
                    data={data} />
                </div>
              </div>
            </div>
          </div>

        </div>
      </React.Fragment>
    );
  }
}

export default Users;
